<template>
  <section class="panel pad">
    <div class="panel-head">
      <h2>访客密码</h2>
    </div>
    <button type="button" class="btn primary" @click="issueCode">生成测试验证码</button>
    <p v-if="issuedCode" class="ok">验证码 {{ issuedCode }}，10 分钟内有效。</p>
    <div v-for="item in passwords" :key="item.id" class="attr-row">
      <input v-model="item.password" />
      <input v-model="item.note" placeholder="备注" />
      <label class="check"><input v-model="item.enabled" type="checkbox" /> 启用</label>
      <button type="button" class="btn ghost sm" @click="savePassword(item)">保存</button>
      <button type="button" class="btn ghost sm" @click="removePassword(item)">删除</button>
    </div>
    <div class="attr-row add">
      <input v-model="newPassword.password" placeholder="新访客密码" />
      <input v-model="newPassword.note" placeholder="备注" />
      <button type="button" class="btn primary sm" @click="addPassword">添加</button>
    </div>
  </section>
</template>

<script>
import {
  adminAddPassword,
  adminDeletePassword,
  adminIssueLoginCode,
  adminListPasswords,
  adminUpdatePassword
} from '../../api/accelService'

export default {
  name: 'AdminPasswords',
  data() {
    return {
      passwords: [],
      issuedCode: '',
      newPassword: { password: '', note: '' }
    }
  },
  mounted() {
    this.load()
  },
  methods: {
    async load() {
      this.passwords = await adminListPasswords()
    },
    async issueCode() {
      const result = await adminIssueLoginCode()
      this.issuedCode = result.code
    },
    async addPassword() {
      if (!this.newPassword.password.trim()) return
      const created = await adminAddPassword({ ...this.newPassword, enabled: true })
      this.passwords.push(created)
      this.newPassword = { password: '', note: '' }
    },
    async savePassword(item) {
      const saved = await adminUpdatePassword(item.id, item)
      Object.assign(item, saved)
    },
    async removePassword(item) {
      await adminDeletePassword(item.id)
      this.passwords = this.passwords.filter((row) => row.id !== item.id)
    }
  }
}
</script>
